
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Home from "./Home";
import News from "./News";
import Store from "./Store";
import Gallery from "./Gallery";
import Members from "./Members";
import Schedule from "./Schedule";
import Activities from "./Activities";
import Achievements from "./Achievements";
import Footer from "./layout/Footer";
import Navbar from "./layout/Navbar";
import { IMerchItem } from "../data";
import { teamLogo } from "../helpers";
import styles from "../assets/style.module.css";
import { CacheManager, Utils, resolveTemplateColors } from "../../../../utils";
import Definition from "../definition";
import { IMember, ITeamWebsite } from "../../../../services";
import { useComponentStyle } from "../../../../hooks/useComponentStyle";

export interface LandingProps {
    basePath: string;
    publicId: string;
    website: ITeamWebsite;
}

function Landing(props: LandingProps) {

    const location = ReactRouterDom.useLocation();
    const { website, basePath, publicId } = props;
    const [cart, setCart] = React.useState<IMerchItem[]>([]);
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [profile, setProfile] = React.useState<IMember | undefined>(CacheManager.get(CacheManager.PROFILE_KEY) as IMember);
    const colors = resolveTemplateColors(Definition, website.design_settings?.scheme_settings?.colors, searchParams);
    useComponentStyle(`
        :root {
            --red: ${colors.danger};
            --green: ${colors.success};
            --muted: ${colors.text_muted};
            --header-bg: ${colors.header_background};
            --text: ${colors.text};
            --text-light: ${colors.text_inverse};
            --paper: ${colors.background};
            --paper-dim: ${colors.background_alt};
            --ink: ${colors.surface_dark};
            --ink2: ${colors.surface_dark_alt};
            --panel: ${colors.surface_dark_panel};
            --accent: ${colors.primary};
            --accent-dark: ${colors.primary_dark};
            --on-accent: ${colors.on_primary};
        }
    `);

    React.useEffect(() => {
        Utils.updateMeta({
            title: website.team.name,
            desc: website.team.description,
            logo: teamLogo(website)!,
        });
    }, [website]);

    React.useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [location.pathname]);

    return (<div className={styles["root"]}>
        <Navbar website={website} basePath={basePath} profile={profile} cartCount={cart.length} onSignOut={() => setProfile(undefined)} />
        <main className={styles["page"]}>
            <ReactRouterDom.Routes>
                <ReactRouterDom.Route path="/news" element={<News website={website} />} />
                <ReactRouterDom.Route path="/members" element={<Members website={website} />} />
                <ReactRouterDom.Route path="/gallery" element={<Gallery website={website} />} />
                <ReactRouterDom.Route path="/activities" element={<Activities website={website} />} />
                <ReactRouterDom.Route path="/achievements" element={<Achievements />} />
                <ReactRouterDom.Route path="/merch" element={<Store cart={cart} onAddToCart={(item) => setCart((c) => (c.some((x) => x.id === item.id) ? c : [...c, item]))} />} />
                <ReactRouterDom.Route path="/schedule" element={<Schedule website={website} publicId={publicId} />} />
                <ReactRouterDom.Route path="/" element={<Home website={website} basePath={basePath} publicId={publicId} />} />
            </ReactRouterDom.Routes>
        </main>
        <Footer website={website} basePath={basePath} profile={profile} />
    </div>);
}

export default Landing;
